import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Truck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { StringList } from "@/components/landing/SectionFields";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/landing`;

export const StoreInfoButton = ({ onSaved }) => {
  const [open, setOpen] = useState(false);
  const [lines, setLines] = useState([]);
  const [vol, setVol] = useState({ 2: 5, 3: 8 });
  const [confirmed, setConfirmed] = useState(true);
  const [busy, setBusy] = useState(false);
  const load = () => axios.get(`${API}/settings`).then((r) => { setLines(r.data.shipping); setVol(r.data.volume); setConfirmed(r.data.confirmed); }).catch(() => {});
  useEffect(() => { load(); const h = () => load(); window.addEventListener("lp-store-saved", h); return () => window.removeEventListener("lp-store-saved", h); }, []);
  const save = async () => {
    setBusy(true);
    try { await axios.put(`${API}/settings`, { shipping: lines, volume: vol }); setConfirmed(true); setOpen(false); toast.success("Salvat pentru toate paginile"); window.dispatchEvent(new Event("lp-store-saved")); onSaved?.(); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid="store-info-btn" onClick={() => setOpen(true)} className={`flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs ${confirmed ? "border-zinc-700 text-zinc-300" : "border-amber-400 bg-amber-400/10 text-amber-200"} hover:border-amber-400`}>
        <Truck className="h-3.5 w-3.5" /> Livrare, retur, garanție{!confirmed && " — verifică!"}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="store-info-dialog" className="max-w-md">
          <DialogHeader><DialogTitle>Livrare, retur, garanție și reduceri</DialogTitle></DialogHeader>
          <p className="text-xs text-zinc-500">Aceste rânduri apar pe toate landing page-urile. AI-ul nu le scrie — completează exact condițiile tale (termen de livrare, cost, retur, garanție).</p>
          <StringList testId="ship-line" value={lines} onChange={setLines} />
          <p className="pt-2 text-xs font-medium text-zinc-700">Reducere la cantitate (exact ca în Shopify)</p>
          <div className="flex gap-3">
            {["2", "3"].map((q) => (
              <label key={q} className="flex items-center gap-1.5 text-xs text-zinc-600">{q} produse −
                <input data-testid={`volume-${q}`} type="number" min="0" max="50" value={vol[q] ?? 0} onChange={(e) => setVol({ ...vol, [q]: Number(e.target.value) })} className="w-14 rounded border border-zinc-300 px-1.5 py-1" /> %
              </label>
            ))}
          </div>
          <button data-testid="store-info-save" onClick={save} disabled={busy} className="flex items-center justify-center gap-2 rounded-full bg-amber-400 py-2.5 text-sm font-semibold text-zinc-950 disabled:opacity-50">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Confirm și salvez
          </button>
        </DialogContent>
      </Dialog>
    </>
  );
};
